import { patientPortalApi } from '@/modules/patient-portal/api/patientPortal.api';
import axios from 'axios';
import { isValidIndianMobile, normalizeIndianMobile, phoneErrorMessage } from './BookingFormParts';
import { apiPatientCategory } from './bookingDetailsHelpers';

const API = process.env.REACT_APP_BACKEND_URL;

export function validateBookingForm(form, category, { skipEmailOtp = false } = {}) {
  if (!form.name.trim() || form.name.trim().length < 2) return 'Please enter your full name';
  if (!form.email.trim() || !form.email.includes('@')) {
    return skipEmailOtp ? 'A valid email is required' : 'A valid email is required for OTP confirmation';
  }
  if (!isValidIndianMobile(form.phone)) {
    return phoneErrorMessage(form.phone) || 'Enter a valid 10-digit Indian mobile number.';
  }
  if (category === 'non_dependent' && !form.relationship) return 'Please select your affiliation';
  return '';
}

export function buildBookPayload(form, picked, visitType, category) {
  return {
    ...form,
    phone: normalizeIndianMobile(form.phone),
    doctor_id: picked.doctor_id,
    doctor_name: picked.doctor_name,
    preferred_date: picked.date,
    preferred_slot: picked.slot,
    visit_type: visitType || 'consulting',
    patient_category: apiPatientCategory(category || 'non_dependent'),
  };
}

export async function submitPublicBook(slug, form, picked, visitType, category, otpPayload) {
  const { data } = await axios.post(`${API}/api/tenant/${slug}/book`, {
    ...buildBookPayload(form, picked, visitType, category),
    challenge_id: otpPayload.challenge_id,
    otp: otpPayload.otp,
  });
  return data;
}

export async function submitPortalBook(form, picked, visitType, category) {
  return patientPortalApi.book(buildBookPayload(form, picked, visitType, category));
}
